const img_path = "./img"

var utils = {

  MONTHS : ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"],

  ICONS : {
      dlv :<img src={require(`${img_path}/delivered_white.png`)} alt="Delivred" />  ,
      dep : <img src={require(`${img_path}/aeroplane_white.png`)} alt ="Aeroplane" /> ,
      rcf : <img src={require(`${img_path}/received_white.png`)} alt="Received" />,
      rcs : <img src={require(`${img_path}/received_white.png`)} alt="Received" />,
      nfd : <img src={require(`${img_path}/mail_white.png`)} alt ="Mail" /> ,
      dep_truck : <img src={require(`${img_path}/truck_white.png`)} alt ="Truck" />,
      plane : <img src={require(`${img_path}/plane.png`)} alt ="Plane" /> ,
      arrival : <img src={require(`${img_path}/arrival.png`)} alt ="arrival" /> ,
      take_off : <img src={require(`${img_path}/take-off.png`)} alt ="take-off" /> ,
  },

  statusNames : {
      "RCF" : "Received from flight",
      "RCS" : "Received from shipper",
      "DEP" : "Departed",
      "DLV" : "Delivered",
      "NFD" : "Notified consignee",
      "DEP_TRUCK" : "Departed on truck",
      "MAN" : "Manifested"
  },

  convertDate : function(dateString, getDateTime = false){

    dateString = dateString ? dateString.toString() : ""
    let month = dateString ?  dateString.substring(5,7) : "" ;
    let day = dateString ?  dateString.substring(8,10) : "" ;
    let hour = dateString ?  dateString.substring(11,13) : "" ;
    let minute = dateString ?  dateString.substring(14,16) : "" ;

    //console.log("#freeM", hour, minute)


    if(month){
      month = parseInt(month)
      month = this.MONTHS[month - 1];
    }

    
    let date = day + month 

    if(getDateTime)
      date = date + " | " + hour + ":" + minute;

  
    return date
  
  },

  convertTime : function (time){

    time = time ? time.toString() : ""
    let hour = ""
    let minute = ""

    if(time){
      hour =  time.slice(0,2) 
      minute = time.slice(2,4)
    }

    return hour + ":" + minute 
   
  },

  mapStatus : function(status, time = false){

    let statusText = ""

    if(!status)
      return "";

    let timestamp = !status.event_date ?  "" : this.convertDate(status.event_date.toString(), true);
    
    let flight_date = !status.flight_date ? "" : this.convertDate(status.flight_date, false) 

    let name = utils.statusNames[status.status];
      name = name ? name : status.discrepancy ? status.discrepancy : status.status
 
    if(status.status === "DEP" || status.status === "RCF" || status.status === "MAN"){

      let part = " on flight";

      if(status.status === "RCF")
        part = "";

      statusText = `${name}${part} ${status.origin}-${status.dest} ${status.carrier}${status.flight_number}/${flight_date}`

      statusText = `${statusText} --- ${status.pieces}pcs ${!status.weight || status.weight === "0.0" ? ""  : status.weight + "kg"}`

    }else{
      statusText = `${name} --- ${status.pieces}pcs ${!status.weight || status.weight === "0.0"  ?  "" : status.weight + "kg"}`
    }

    if(time)
      statusText = `${statusText} -- ${status.airport}, ${timestamp}*`

    return statusText

  }

}

export default utils